/* eslint frontbucket-patterns/no-new-sagas: "warn" */
import * as Sentry from '@sentry/browser';
import { call, put, select, take } from 'redux-saga/effects';

import { getCurrentPullRequestUrlPieces } from 'src/redux/pull-request/selectors';
import urls from 'src/redux/pull-request/urls';
import authRequest, { jsonHeaders } from 'src/utils/fetch';

import { TASK_CREATE } from '../actions';

import { getErrorMessage } from './utils/get-error-message';

export default function* createTaskSaga() {
  while (true) {
    const {
      payload: { task, commentId, isTaskPending, isGlobal },
    } = yield take(TASK_CREATE.REQUEST);
    const { owner, slug, id } = yield select(getCurrentPullRequestUrlPieces);

    const authWrapped = authRequest(urls.api.v20.tasks(owner, slug, id), {
      method: 'POST',
      headers: jsonHeaders,
      body: JSON.stringify({
        content: {
          raw: task,
        },
        pending: !!isTaskPending,
        ...(commentId && {
          comment: {
            id: parseInt(commentId, 10),
          },
        }),
      }),
    });

    try {
      const response: Response = yield call(fetch, authWrapped);

      if (!response.ok) {
        const message: string = yield call(getErrorMessage, response.clone());
        throw new Error(message);
      }
      // @ts-ignore
      const newTask = yield response.json();
      yield put({
        type: TASK_CREATE.SUCCESS,
        payload: { commentId, newTask, isGlobal },
      });
    } catch (e) {
      Sentry.captureException(e);
      yield put({
        type: TASK_CREATE.ERROR,
        payload: { isGlobal, commentId, error: e.message },
      });
    }
  }
}
